<template>
  <div class="notification is-primary" @click="$emit('dismiss')" style="cursor: pointer">
    <slot />
  </div>
</template>
